
class HXFormFieldMarkerCheckbox extends HXFormField {

    /** @private */
    inputNameHidden = null;
    /** @private */
    inputObjHidden = null;
    /** @private */
    inputNameHidden2 = null;
    /** @private */
    inputObjHidden2 = null;

    constructor(inputName,formName) {
        super(inputName, formName);

        //Input Hidden mit aktuellen Values
        this.inputNameHidden = this.inputName + "_hidden";
        var obj = null;
        // hidden-Objekt holen
        if (this.formName!==null && document.forms[this.formName]!==undefined) {
            obj = document.forms[this.formName].elements[this.inputNameHidden]; //absichtlich kein JQuery -> getAttribute
        }
        if (obj===undefined || obj===null) { //z.B. HXFormFieldSignatur ist kein echtes Inputfeld
            obj = document.getElementsByName(this.inputNameHidden)[0];  //absichtlich kein JQuery -> getAttribute
        }
        this.inputObjHidden = obj;

        // hidden2-Objekt holen
        this.inputNameHidden2 = this.inputName;
        if (this.formName!==null && document.forms[this.formName]!==undefined) {
            obj = document.forms[this.formName].elements[this.inputNameHidden2]; //absichtlich kein JQuery -> getAttribute
        }
        if (obj===undefined || obj===null) { //z.B. HXFormFieldSignatur ist kein echtes Inputfeld
            obj = document.getElementsByName(this.inputNameHidden2)[0];  //absichtlich kein JQuery -> getAttribute
        }
        this.inputObjHidden2 = obj;


    }

    /**
     * Alle Ids von aktiven, 'locked' und 'searchHidden' Eintraegen mit Eigenschaft checked=1 im InputHidden speichern
     * 'hidden' Eintreage werden nicht beruecksichtig
     */
    updateHiddenByMarker() {
        var ids = [];
        $('div#' + this.inputName + ' .checked:not(\".hidden\")').each((key, obj) => {
            ids.push(obj.getAttribute('data-id'));
        });
        this.setValue(hx.implode(',', ids));
    }

    /**
     *  Alle Checkboxen auf checked=1 deren ID in der InputHidden gefunden wird
     * Achtung: Bereits Checked-Checkboxen die nicht in der hidden Variable sind bleiben unver�ndert
     */
    updateMarkerByHidden(){
        var ids = hx.explode(',', this.getValue());
        ids.forEach((id) => {
            if(id > 0) this.setChecked(id);
        });
    }

    /**
     * Alle li inkl. Checkboxen im Checkboxmarker entfernen
     * @param {boolean} clearHidden Wenn true dann werden auch alle Werte aus der hidden Variable entfernt
     */
    clearAllEntry(clearHidden) {
        if(clearHidden === undefined || clearHidden === null) clearHidden = false;
        $('div#' + this.inputName + ' li').remove();
        if(clearHidden) this.setValue('');
    }

    /**
     * Neue Checkboxen hinzufuegen - InputHidden bleibt unveraendert
     * @param {json} obj Objekt im JSON Format {1: {id:1, content: 'bla'},2: {id:2, content: 'bla1'}}
     */
    addEntryByDataObject(obj){
        var html = "";
        var sort = 0;
        var title = '';
        $.each(obj, (key, objElem) => {
            html +=  "<li data-sort=\"" + sort + "\" data-id=\"" + objElem.id + "\"" +
                     " data-content=\"" + $("<span>" + objElem.content + "</span>").text().toLowerCase() +
                     "\">" + objElem.content + "</li>";
            sort++;
        });
        $('div#' + this.inputName + " ul.content").append(html);
        //Suche aktualisieren
        this.search($('input[name=' + this.inputName + '_searchfield]').val());
    }


    /**
     * Alle Checkboxen auf checked=0 setzten und nur jene der uebergebenen IDs anzeigen. Alle anderen via 'hidden' ausblenden.
     * Die InputHidden wird aktualisiert
     * @param {string} commaSeparatedIds Checkbox Ids als kommaseparierter String zb. "1,2,3,14"
     */
    filterByIds(commaSeparatedIds){
        var arr = hx.explode(',', commaSeparatedIds);
        var allChecked = this.getAllCheckedValues();
        $('div#' + this.inputName + ' li').addClass('hidden').removeClass('checked').data('checked', 0); //setzt Hidden auch autom. auf leer
        var divContainer = $('div#' + this.inputName);
        divContainer.find('[data-id=\"' + arr.join('\"],[data-id=\"') + '\"]').removeClass('hidden');
        divContainer.find('[data-id=\"' + allChecked.join('\"],[data-id=\"') + '\"]').addClass('checked').data('checked', 1);
        this.updateHiddenByMarker();
    }


    /**
     * Blendet eine Checkbox via 'hidden' aus, ohne checked=1/0 Zustand zu �ndern
     * @param {int|string} id Id der Checkbox welche versteckt werden soll
     * @param {boolean} updateHidden wenn true: Hiddenvariable aktualisieren (updateHiddenByMarker())
     */
    hideEntry(id,updateHidden) {
        var divContainer = $('div#' + this.inputName);
        divContainer.find('[data-id=\"' + id + '\"]').addClass('hidden');
        if (updateHidden) this.updateHiddenByMarker();
    }

    /**
     * Eine 'hidden' Checkbox sichtbar machen, ohne checked=1/0 Zustand zu �ndern
     * @param {int|string} id Id der Checkbox welche sichtbar gemacht werden soll
     * @param {boolean} updateHidden wenn true: Hiddenvariable aktualisieren (updateHiddenByMarker())
     */
    showEntry(id,updateHidden) {
        var divContainer = $('div#' + this.inputName);
        divContainer.find('[data-id=\"' + id + '\"]').removeClass('hidden');
        if (updateHidden) this.updateHiddenByMarker();
    }

    /**
     * Liefert alle Ids aller existierenden Checkboxen, unabhaengig von deren Sichtbarkeit und checked-Status
     * @returns {array}
     */
    getAlleIds() {
        var values = [];
        $('div#' + this.inputName + ' li').each(function(){
            values.push($(this).data('id'));
        });
        return values;
    }

    /**
     * Ruft filterByIds(ids) auf
     * @param {string} commaSeparatedIds Checkbox Ids als kommaseparierter String zb. "1,2,3,14"
     */
    setFilterByIds(commaSeparatedIds) {
        this.filterByIds(commaSeparatedIds);
    }

    /**
     * Nur Checkboxen deren Label searchString entghalten angezeigt. Alle anderen werden via 'searchHidden' ausgeblendet
     * InputHidden und checked-Status bleiben unveraendert
     * @param {string|null} searchString String nach dem gesucht werden soll, null oder '' zeigt alle Checkboxen an
     * @returns {boolean}
     */
    search(searchString){
        if(searchString === undefined) return;
        if (searchString === null) searchString = '';
        if(searchString.length !== 0){
            searchString = searchString.toLowerCase();
            $('div#' + this.inputName + ' li[data-content*=\"' + searchString + '\"]').removeClass('searchHidden');
            $('div#' + this.inputName + ' li:not([data-content*=\"' + searchString + '\"])').addClass('searchHidden');
        }else{
            $('div#' + this.inputName + ' li').removeClass('searchHidden');
        }

        this.sortASC();
        return true;
    }

    /**
     * Liefert IDs aller aktiven, 'locked' und 'searchHidden' Checkboxen mit checked=1
     * @returns {array}
     */
    getAllCheckedValues(){
        var ids = [];
        $('div#' + this.inputName + ' .checked:not(\".hidden\")').each((key, obj) => {
            ids.push($(obj).data('id'));
        });
        return ids;
    }

    /**
     * Liefer IDs aller aktiven und 'searchHidden' Checkboxen, unabh�ngig vom checked-Status
     * @returns {array}
     */
    getAllVisibleIds() {
        var values = [];
        $('div#' + this.inputName + ' li:not(\".locked, .hidden\")').each(function(){
            values.push($(this).data('id'));
        });
        return values;
    }


    /**
     * Anhaken aller aktiven Checkboxen mit aktualisieren InputHidden. 'locked', 'searchHidden' und 'hidden' bleiben unver�ndert.
     * @param {boolean} callChangeEvt triggert Change Event wenn true oder undefined
     */
    checkAllValues(callChangeEvt){
        if(callChangeEvt === undefined) callChangeEvt = true;

        $('div#' + this.inputName + ' li:not(\".searchHidden, .locked, .hidden\")').each((index,elem) => {
            if($(elem).data("checked") === 0 || $(elem).hasClass('checked') === false){
                $(elem).addClass('checked').data('checked', 1);
            }
        });
        this.updateHiddenByMarker();
        if(callChangeEvt) $('div#' + this.inputName).trigger('change');
    }


    /**
     * Abhaken aller aktiven Checkboxen mit aktualisieren InputHidden. 'locked', 'searchHidden' und 'hidden' werden bleiben unver�ndert.
     * @param {boolean} callChangeEvt triggert Change Event wenn true oder undefined
     */
    unCheckAllValues(callChangeEvt) {
        if(callChangeEvt === undefined) callChangeEvt = true;

        $('div#' + this.inputName + ' li:not(\".searchHidden, .locked, .hidden\")').each((index,elem) => {
            $(elem).removeClass('checked').data('checked', 0);
        });
        this.updateHiddenByMarker();
        if(callChangeEvt) $('div#' + this.inputName).trigger('change');
    }

    /**
     * Invertiert alle Checkboxen ausser 'locked', 'searchHidden' und 'hidden' mit aktualisieren der InputHidden
     * @param {boolean} callChangeEvt triggert Change Event wenn true oder undefined
     */
    invertCheckboxes(callChangeEvt){
        if(callChangeEvt === undefined) callChangeEvt = true;
        $('div#' + this.inputName + ' li:not(\".searchHidden, .locked, .hidden\")').each((index,elem) => {
            if(hx.cint($(elem).data('checked')) === 1){
                $(elem).removeClass('checked').data('checked', 0).data('id');
            }else{
                $(elem).addClass('checked').data('checked', 1).data('id');
            }
        });
        this.updateHiddenByMarker();
        if(callChangeEvt) $('div#' + this.inputName).trigger('change');
    }


    /**
     * Checkboxen der uebergebenen IDs 'locked' (inaktiv) machen, checked-Status bleibt unveraendert
     * @param {string} commaSeparatedIds Checkbox Ids als kommaseparierter String zb. "1,2,3,14"
     * @param {boolean} callChangeEvt triggert Change Event wenn true oder undefined
     */
    setDisabledIds(commaSeparatedIds, callChangeEvt){
        if(callChangeEvt === undefined) callChangeEvt = true;
        var arr = hx.explode(',', commaSeparatedIds);
        $('div#' + this.inputName).find('[data-id=\"' + arr.join('\"],[data-id=\"') + '\"]').addClass('locked');
        if(callChangeEvt) $('div#' + this.inputName).trigger('change');
    }

    /**
     * Alle 'locked' (inaktive) zu aktiven Checkboxen machen, checked-Status bleibt unveraendert
     * @param {boolean} callChangeEvt triggert Change Event wenn true oder undefined
     */
    enableAllIds(callChangeEvt){
        if(callChangeEvt === undefined) callChangeEvt = true;
        $('div#' + this.inputName).find('.locked').removeClass('locked');
        if(callChangeEvt) $('div#' + this.inputName).trigger('change');
    };



    /**
     * checked=1 Checkboxen werden im Marker vor den checked=0 aufgelistet, jeweils sortiert nach "data-sort" Attribut
     * wobei nur die kleinere von beiden Gruppen (checked oder unchecked) durchsortiert wird
     * 'searchHidden' ausgeblendete werden ebenfalls mit ber�cksichtigt
     */
    sortASC(){
        var checkedBoxes = $('div#' + this.inputName + ' li.checked');
        var uncheckedBoxes = $('div#' + this.inputName + ' li:not(\".checked\")');
        var sortFunction = function(a, b){
            if($(a).data('sort') < $(b).data('sort')) return -1;
            return 1;
        };
        if(checkedBoxes.length < uncheckedBoxes.length){
            checkedBoxes.sort(sortFunction).prependTo('div#' + this.inputName + ' > ul');
        }else{
            uncheckedBoxes.sort(sortFunction).appendTo('div#' + this.inputName + ' > ul');
        }
    };

    /**
     * checked=1 Checkboxen werden im Marker vor den checked=0 aufgelistet, jeweils sortiert nach "data-sort" Attribut
     * 'searchHidden' ausgeblendete werden ebenfalls mit ber�cksichtigt
     */
    sortASCAll(){
        var checkedBoxes = $('div#' + this.inputName + ' li.checked');
        var uncheckedBoxes = $('div#' + this.inputName + ' li:not(\".checked\")');

        var sortFunction = function(a, b){
            if($(a).data('sort') < $(b).data('sort')) return -1;
            return 1;
        };

        checkedBoxes.sort(sortFunction).prependTo('div#' + this.inputName + ' > ul');
        uncheckedBoxes.sort(sortFunction).appendTo('div#' + this.inputName + ' > ul');
    }


    /**
     * Eine Checkbox checked=1 setzen, unabhaenig von der Sichtbarkeit
     * @param {int|string} id Id der Checkbox welche angehakt werden soll
     * @param {boolean} setActiveAndUpdateHidden wenn true, Fokus auf Checkbox und InputHidden aktualisieren
     */
    setChecked (id, setActiveAndUpdateHidden){
        var addClasses = [];
        addClasses.push('checked');
        if(setActiveAndUpdateHidden){
            $('div#' + this.inputName + ' .active').removeClass('active');
            addClasses.push('active');
        }
        $('div#' + this.inputName + ' li[data-id=' + id + ']').addClass(hx.implode(' ', addClasses)).data('checked', 1);
        if(setActiveAndUpdateHidden) this.updateHiddenByMarker();
    }

    /**
     * Eine Checkbox checked=0 setzen, unabhaenig von der Sichtbarkeit
     * @param {int|string} id Id der Checkbox welche angehakt werden soll
     * @param {boolean} unsetActiveAndUpdateHidden wenn true, Fokus auf Checkbox und InputHidden aktualisieren
     */
    setUnChecked(id, unsetActiveAndUpdateHidden){
        if(unsetActiveAndUpdateHidden) $('div#' + this.inputName + ' .active').removeClass('active');

        $('div#' + this.inputName + ' li[data-id=' + id + ']').removeClass('checked').addClass('active').data('checked', 0);
        if(unsetActiveAndUpdateHidden) this.updateHiddenByMarker();
    }

    /**
     * Ids als kommaseparierterten String in InputHidden setzen
     * @param {string} commaSeparatedIds
     */
    setValue(commaSeparatedIds) {
        if (this.getEditable()===true) { //Im Readonly-Modus gibt es keine inputObjHidden und inputObjHidden2
            this.inputObjHidden.value = commaSeparatedIds;
            this.inputObjHidden2.value = commaSeparatedIds;
        }
        //this.updateMarkerByHidden(); - Darf nicht hier erfolgen!! Muss wie bisher manuell durch UpdateMarkerbyHidden erfolgen!!!!
    }

    /**
     * Liefert die Ids als kommaseparierter String von der InputHidden zur�ck
     * @returns {string}
     */
    getValue() {
        if (this.getEditable()===true) { //Im Readonly-Modus gibt es keine inputObjHidden und inputObjHidden2
            return this.inputObjHidden.value;
        } else {
            return this.getValueOld();
        }
    }


    /**
     * @param {string} alertResult
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            var value = this.getValue();
            if (this.getOptional()===false && value === '') {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            }
            if (alertResult===true) super._validateFieldAlert();
        }
        return this.validationPassed;
    }

    /**
     * @param optional
     */
    setOptional(optional) {
        super.setOptional(optional,'marker');
    }

    /**
     * @return boolean
     */
    getTooltipDisplay() {
        return this.inputObj.getAttribute("data-hx-tooltip-display") === 'true';
    }

    /**
     * Events einhaengen
     */
    displayInit(moveCheckedToTop) {
        if (this.fieldExists()===true && this.getEditable() === true) {
            //Checkboxen anhand hidden setzen
            this.updateMarkerByHidden();
            //Checked Eintraege nach oben schieben
            if (moveCheckedToTop === true) this.sortASC();


            var timerId = 0;
            if (document.getElementsByName(this.inputName + "_searchfield").length>0){
                document.getElementsByName(this.inputName + "_searchfield")[0].addEventListener("keyup", (event) => {
                    if(event.key === "Tab") return true;
                    var searchFieldObj = $(event.target);
                    if(timerId !== 0) clearTimeout(timerId);
                    //400ms nach Tastendruck Suchfeld deaktiveren und Suche starten
                    timerId = setTimeout(() => {
                        searchFieldObj.attr('disabled', true);
                        var returnValue = false;
                        returnValue = this.search(searchFieldObj.val());
                        //Wenn Suche fertig und gueltig, Suchfeld nach 100ms wieder aktivieren
                        searchFieldObj.attr('disabled', false);
                        searchFieldObj.trigger('focus');
                    }, 400);

                });
            }

            //Event fuer Checkbox anklicken
            //Damit nachtraeglich hinzugefuege li-Elemente auch auf den Event reagieren,
            // wird dieser auf den CheckboxMarker gesetzt und danach das event.target auf 'li' geprueft
            $('div#' + this.inputName).on("click", (event) => {
                if (event.target && event.target.matches("li")) {
                    var clickedElem = $(event.target);
                    //gueltiges Element?
                    if (clickedElem.hasClass('locked')) return;
                    if (clickedElem.prop("tagName").toUpperCase() !== 'LI') return;
                    //pruefen ob li angeclickt wurde
                    var checked = hx.cint($(event.target).data('checked'));
                    var id = $(event.target).data('id');

                    if (checked === 1) this.setUnChecked(id, true);
                    else this.setChecked(id, true);
                    $('div#' + this.inputName).trigger('change');
                }
            });

            //Tooltips je Eintrag anzeigen, wenn gewuenscht
            if (this.getTooltipDisplay() === true) {
                $('div#' + this.inputName).on("mouseover", (event) => {
                    if (event.target && event.target.matches("li")) {
                        if ($(event.target).attr('title') === undefined) $(event.target).attr('title', $(event.target).text());
                    }
                });
            }

            //Event Checkboxmarker verliert Fokus - Checkbox mit Fokus nicht mehr blau einfaerben
            document.querySelector('div#' + this.inputName).addEventListener("focusout", (event) => {
                $(event.target).find('li.last-focus').removeClass('last-focus');
                $(event.target).find('.active').removeClass('active').addClass('last-focus');
                if ($(this.inputObj).attr("data-has_focus")=="1"){
                    $(this.inputObj).attr("data-has_focus","0");
                    this.inputObj.dispatchEvent(new Event('blur'));
                }
            });

            //Event Checkboxmarker erhaellt Fokus - Checkbox mit Fokus blau einfaerben
            document.querySelector('div#' + this.inputName).addEventListener("focusin", (event) => {
                var focusedElem = $(event.target).find('li.last-focus');
                if (focusedElem.length === 0 || focusedElem.hasClass('searchHidden') || focusedElem.hasClass('hidden')) {
                    $('div#' + this.inputName + ' li:not(\".searchHidden, .locked, .hidden\")').first().addClass('active');
                    $('div#' + this.inputName).removeClass('last-focus');
                } else {
                    $('div#' + this.inputName).find('li.last-focus').addClass('active').removeClass('last-focus');
                }
            });

            //Event fuer Tastendruck
            document.querySelector('div#' + this.inputName).addEventListener("keydown", (event) => {
                var key = event.key;
                var currObj = $(event.target).find('.active');
                if (currObj.length === 0) return;

                if (key === "ArrowDown" && !event.ctrlKey) { //ArrowDown
                    var nextObj = currObj.next();
                    while (nextObj.hasClass('hidden') || nextObj.hasClass('searchHidden') || nextObj.hasClass('locked')) {
                        nextObj = nextObj.next();
                    }
                    if (nextObj.length !== 0) {
                        currObj.removeClass('active');
                        nextObj.addClass('active')
                    }
                    event.preventDefault();

                } else if (key === "ArrowUp" && !event.ctrlKey) { //ArrowUp
                    var prevObj = currObj.prev();
                    while (prevObj.hasClass('hidden') || prevObj.hasClass('searchHidden') || prevObj.hasClass('locked')) {
                        prevObj = prevObj.prev();
                    }
                    if (prevObj.length !== 0) {
                        currObj.removeClass('active');
                        prevObj.addClass('active')
                    }
                    event.preventDefault();

                } else if (key === " ") { //Space
                    if (currObj.hasClass('checked')) this.setUnChecked(currObj.data('id'), true);
                    else this.setChecked(currObj.data('id'), true);
                    $('div#' + this.inputName).trigger('change');
                    event.preventDefault();
                    return false;
                }

                //Aktuelle Position sichtbar halten - hinscrollen
                var viewportHeight = $(event.target).height();
                var divScrollTop = $(event.target).scrollTop();
                var minTop = divScrollTop;
                var maxTop = divScrollTop + viewportHeight;
                var myElement = $(event.target).find('li.active');
                var elementTop = myElement.position().top + divScrollTop;
                var elementHeight = myElement.height();
                if (elementTop >= (maxTop - 20)) $(event.target).scrollTop(elementTop - viewportHeight + elementHeight);
                else if (elementTop <= (minTop - 5)) $(event.target).scrollTop(elementTop);

            });
        }
    }

}